/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */

// eslint-disable-next-line import/no-anonymous-default-export
export default {
	'help.loading': 'Loading',
	'help.header': 'Help',
	'help.header_whats_new': 'What\'s new',
	'help.close': 'Close',
	'help.navigation.back': 'Back',
	'help.search.placeholder': 'Search help articles',
	'help.article_rating.title': 'Was this helpful?',
	'help.article_rating.option.yes': 'Yes',
	'help.article_rating.option.no': 'No',
	'help.article_rating.form.title': 'Tell us why you gave this rating',
	'help.article_rating.accurate': 'It isn\'t accurate',
	'help.article_rating.clear': 'It isn\'t clear',
	'help.article_rating.relevant': 'It isn\'t relevant',
	'help.article_rating.form.submit': 'Submit',
	'help.article_rating.form.success': 'Thanks!',
	'help.article_rating.form.failed': 'We couldn\'t submit your feedback.',
	'help.article_rating.form.failed.try_again': 'Try again',
	'help.article_rating.form.cancel': 'Cancel',
	'help.article_rating.form.contact_me': 'Atlassian can contact me about this feedback',
	'help.article_list_item.type.whats_new': 'WHAT\'S NEW',
	'help.article_list_item.type.help-article': 'HELP ARTICLE',
	'help.related_article.title': 'Related articles',
	'help.related_article.endpoint-error.title': 'We\'re having some trouble',
	'help.related_article.endpoint-error.description': 'It\'s taking us longer than expected to show this content. It\'s probably a temporary problem.',
	'help.related_article.endpoint-error.button-label': 'Try Again',
	'help.search_results.search_external_site': 'Can\'t find what you\'re looking for? Try again with a different term or <a>search all online help articles</a>.',
	'help.search_results.no_results': 'We can\'t find anything matching your search',
	'help.search_results.no_results_line_two': 'Try again with a different term or <a>search all online help articles</a>.',
	'help.article_error.title': 'Something\'s gone wrong',
	'help.article_error.text': 'Something prevented the page from loading. We will try to reconnect automatically.',
	'help.article_error.button_label': 'Try now',
	'help.search_error': 'We are having some trouble',
	'help.search_error_line_two': 'It\'s taking us longer than expected to show this content. It\'s probably a temporary problem.',
	'help.search_error.button_label': 'Retry',
	'help.whats_new.button_label': 'Find out what’s changed in {productName}',
	'help.whats_new.button_label_without_product_name': 'Find out what’s changed',
	'help.whats_new.button_tooltip': 'See our latest feature announcements, improvements, bug fixes, and more.',
	'help.whats_new.filter_select_option_all': 'All release types',
	'help.whats_new.filter_select_option_new': 'New',
	'help.whats_new.filter_select_option_improvement': 'Improvement',
	'help.whats_new.filter_select_option_fix': 'Fix',
	'help.whats_new.filter_select_option_removed': 'Removed',
	'help.whats_new.filter_select_option_experiment': 'Experiment',
	'help.whats.new_no_results': 'We can’t find any recent releases of that type.',
	'help.whats.new_no_results_info': 'We only display three months of recent releases.',
	'help.whats.new_no_results_clear_filter_button_label': '<button>Clear the filter</button> to try again.',
	'help.whats_new.related_links.support': 'Support documentation',
	'help.whats_new.related_links.community': 'Discuss with community',
	'help.show_more_button.label_more_articles': '{numberOfItemsLeft, plural, one {Show # more article} other {Show # more articles}}',
	'help.show_more_button.label_more_changes': '{numberOfItemsLeft, plural, one {Show # more change} other {Show # more changes}}',
	'help.show_more_button.label_less': 'Show less',
	'helpPanel.search.back': 'Back',
	'help.search_tab.search': 'Search',
	'help.search_tab.ai': 'Ask AI',
	'help.need_more_help.ai': 'Ask AI',
	'help.need_more_help.text': 'Need more help?',
	'help.whats_new.filter_select_label': 'Select a Category',
};
